import React, { useState } from 'react';

const ContactPage = () => {
  // State for handling success message
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const form = e.target;
    const formData = new FormData(form);

    // Use the provided Getform endpoint
    const getformEndpoint = 'https://getform.io/f/avrryxja';

    try {
      // Submit the form data to Getform
      const response = await fetch(getformEndpoint, {
        method: 'POST',
        body: formData,
      });

      // If submission is successful, display success message
      if (response.ok) {
        setIsSubmitted(true);
        // Optionally reset the form after successful submission
        form.reset();
      } else {
        console.error('Error submitting form');
      }
    } catch (error) {
      console.error('Error submitting form:', error);
    }
  };

  return (
    <div className="bg-white font-poppins py-20">
      <div className="container mx-auto px-5 md:px-10">
        <h2 className="text-secondary text-4xl font-extrabold text-center mb-10">Contact Me</h2>

        <form
          action="https://getform.io/f/avrryxja" // Your Getform endpoint
          method="POST"
          onSubmit={handleSubmit}
          className="bg-gray-100 p-8 rounded-lg shadow-lg"
        >
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
            <div>
              <label className="block text-secondary mb-2" htmlFor="firstName">First Name</label>
              <input
                type="text"
                id="firstName"
                name="firstName" // Add name attributes to map form data
                required
                className="border border-gray-300 rounded-md w-full p-2 focus:outline-none focus:ring-0"
              />
            </div>
            <div>
              <label className="block text-secondary mb-2" htmlFor="lastName">Last Name</label>
              <input
                type="text"
                id="lastName"
                name="lastName" // Add name attributes to map form data
                required
                className="border border-gray-300 rounded-md w-full p-2 focus:outline-none focus:ring-0"
              />
            </div>
          </div>

          <div className="mb-6">
            <label className="block text-secondary mb-2" htmlFor="phone">Phone Number</label>
            <input
              type="tel"
              id="phone"
              name="phone" // Add name attributes to map form data
              required
              className="border border-gray-300 rounded-md w-full p-2 focus:outline-none focus:ring-0"
            />
          </div>

          <div className="mb-6">
            <label className="block text-secondary mb-2" htmlFor="email">Email Address</label>
            <input
              type="email"
              id="email"
              name="email" // Add name attributes to map form data
              required
              className="border border-gray-300 rounded-md w-full p-2 focus:outline-none focus:ring-0"
            />
          </div>

          <div className="mb-6">
            <label className="block text-secondary mb-2" htmlFor="message">Message</label>
            <textarea
              id="message"
              name="message" // Add name attributes to map form data
              rows="4"
              required
              className="border border-gray-300 rounded-md w-full p-2 focus:outline-none focus:ring-0"
            />
          </div>

          <button
            type="submit"
            className="bg-secondary border-2 border-secondary px-8 py-4 rounded-lg font-bold text-white transition-all duration-300 transform hover:bg-white hover:text-secondary hover:shadow-lg"
          >
            Send Message
          </button>
        </form>

        {/* Success message */}
        {isSubmitted && (
          <div className="mt-6 text-center text-green-500 font-bold">
            Message sent successfully!
          </div>
        )}
      </div>
    </div>
  );
};

export default ContactPage;
